import { Box, ToggleButtonGroup, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Key, KeyQuality, KeyRoot } from 'services/store/ai/types';
import ToggleButton from '../../../ToggleButton';
import { ControlComponentProps } from '../../types';

const ROOT_ROWS = [
  [
    KeyRoot.CSharp,
    KeyRoot.DSharp,
    KeyRoot.FSharp,
    KeyRoot.GSharp,
    KeyRoot.BFlat,
  ],
  [KeyRoot.C, KeyRoot.D, KeyRoot.E, KeyRoot.F, KeyRoot.G, KeyRoot.A, KeyRoot.B],
];

type KeySelectorProps = ControlComponentProps<Key['value']>;

const KeySelector = ({ value, onChange }: KeySelectorProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
      }}
    >
      <ToggleButtonGroup
        value={value.quality}
        exclusive
        onChange={(_, quality) => quality && onChange({ ...value, quality })}
        fullWidth
      >
        {Object.values(KeyQuality).map((item) => (
          <ToggleButton
            key={item}
            value={item}
            sx={{
              ':first-of-type': {
                borderTopLeftRadius: theme.spacing(0.5),
                borderBottomLeftRadius: theme.spacing(0.5),
              },
              ':last-of-type': {
                borderTopRightRadius: theme.spacing(0.5),
                borderBottomRightRadius: theme.spacing(0.5),
              },
            }}
          >
            {t(`aiMusicGenerator:key:quality:${item}`)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(1),
        }}
      >
        {ROOT_ROWS.map((roots, index) => (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            {roots.map((item) => (
              <ToggleButton
                key={item}
                selected={item === value.root}
                value={item}
                onChange={(_: unknown, root: KeyRoot) =>
                  onChange({ ...value, root })
                }
                sx={{
                  width: index === 0 ? '18%' : '10%',
                  padding: 0,
                  fontSize: 10,
                  height: theme.spacing(3.5),
                  borderRadius: theme.spacing(0.35),
                }}
              >
                {t(`aiMusicGenerator:key:root:${item}`)}
              </ToggleButton>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default KeySelector;
